import { CartAddEvent } from './events.js';


export async function fetchCartItems() {
  try {
    const response = await fetch('/cart.js');

    if (!response.ok) {
      const stringifiedResp = await stringifyResponse(response);
      console.log(`stringifiedResp`, stringifiedResp);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return response.json();
  } catch (err) {
    console.error('[fetchCartItems] error fetching cart', err)
  }
}


/** @param {number} variantId @param {number} quantity @param {number|null} sellingPlanId */
export async function addToCart(variantId, quantity, sellingPlanId) {
  try {        
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const cartItemComponentsSectionIds = [...cartItemsComponents]
      .filter((/** @type {any} */ item) => item instanceof HTMLElement && item.dataset.sectionId)
      .map((/** @type {any} */ item) => item.dataset.sectionId);

    const requestBody = { 
      items: [{
        id: variantId,
        quantity,
        selling_plan: sellingPlanId || undefined,
      }],
      sections: cartItemComponentsSectionIds,
      sections_url: window.location.pathname,
    };
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });
    
    if (!response.ok) {
      const stringifiedResp = await stringifyResponse(response);
      console.log(`stringifiedResp`, stringifiedResp);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json = await response.json();   

    const cartAddEvent = new CustomEvent(CartAddEvent.eventName, {
      bubbles: true,
      detail: { 
        item: json,
        data: {
          sections: json.sections || {}
        }
      }
    });
    document.dispatchEvent(cartAddEvent);
    
    const cartDrawer = document.querySelector('cart-drawer-component');
    // @ts-ignore
    if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();

    // Gift-with-purchase: Add free Microfibre Cloth when Ultimate Eye Vitamins is added
    await addGiftWithPurchase(cartItemComponentsSectionIds);

    return fetchCartItems();
  } catch (error) {
    console.error('Error adding to cart:', error);
  }
}


/**
 * Gift-with-purchase: Add a free Microfibre Cloth if not already in cart.
 * @param {string[]} sectionIds
 */
async function addGiftWithPurchase(sectionIds) {
  const MICROFIBRE_CLOTH_PRODUCT_ID = 7231067947198;

  try {
    // Check if the gift is already in the cart
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) return;
    const cart = await cartResponse.json();
    const alreadyInCart = cart.items?.some((/** @type {{ product_id: number }} */ item) => item.product_id === MICROFIBRE_CLOTH_PRODUCT_ID);
    if (alreadyInCart) return;

    // Fetch the gift product to get its first available variant
    const giftResponse = await fetch('/products/microfibre-cloth.js');
    if (!giftResponse.ok) return;
    const giftProduct = await giftResponse.json();
    const variant = giftProduct.variants?.find((/** @type {{ available: boolean }} */ v) => v.available);
    if (!variant) return;

    const addResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variant.id, quantity: 1 }],
        sections: sectionIds,
        sections_url: window.location.pathname,
      }),
    });

    if (addResponse.ok) {
      const json = await addResponse.json();
      const cartAddEvent = new CustomEvent(CartAddEvent.eventName, {
        bubbles: true,
        detail: {
          item: json,
          data: { sections: json.sections || {} },
        },
      });
      document.dispatchEvent(cartAddEvent);
    }
  } catch (error) {
    console.error('[Gift-with-purchase] Error adding gift item:', error);
  }
}


/** @param {Response} response */
export async function stringifyResponse(response, numIndent = 4) {
  const result = {
    status: response.status,
    statusText: response.statusText,
    ok: response.ok,
    url: response.url,
    type: response.type,
    body: '',
  };

  try {
    const clonedResponse = response.clone();
    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      result.body = await clonedResponse.json();
    } else if (contentType.includes('text/')) {
      result.body = await clonedResponse.text();
    } else {
      result.body = `<${contentType || 'unknown'} content>`;
    }
  } catch (err) {
    result.body = `<unable to read body: ${err instanceof Error ? err.message : 'unknown error'}>`;
  }
  return JSON.stringify(result, null, numIndent);
}